import "whatwg-fetch";
import React from "react";
import { connect } from "react-redux";
import Button from "signoxe/components/widgets/Button";
import "./styles.scss";
import "./scroll.scss";
import {
  uploadAsset,
  addZipAsset,
  updateScrollerAsset,
  fetchAssets,
  fetchScrollerTemplates,
} from "signoxe/actions";
import {
  getScrollerTemplates,
  getFilteredAssetsByQuery,
} from "signoxe/selectors";

import JSZip from "jszip";

class ScrollerAppPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedBackgroundType: "none",
      selectedBackgroundColor: "#ffffff", // State for selected background color
      selectedBackgroundImage: "",
      textInput: "Ticker Title", // State for text input
      selectedTextEffect: "none", // State for selected text effect
      activeTab: "editor",
      selected: null,
      selectedFontFamily: "Arial",
      selectedMotionEffect: "none",
      selectedTextColor: "#000000",
      selectedSpeed: "normal",
      fileName: "",
      selectedAnimationDirection: "normal",
      selectedFontSize: "2rem",
      modifyPrevAsset: false,
      selectedAsset: null,
      searchBgImage: "",
      assetSearchQuery: "",
    };

    this.textEffects = [
      "None",
      "Bold",
      "Italic",
      "Underline",
      "Uppercase",
      "Lowercase",
      "Capitalize",
    ];

    this.fontFamilies = [
      "Arial",
      "Helvetica",
      "Times New Roman",
      "Courier New",
      "Verdana",
      "Georgia",
      "Trebuchet MS",
      "Palatino",
      "Garamond",
      "Bookman",
      "Century Gothic",
      "Lucida Console",
      "Impact",
      "Tahoma",
      "Comic Sans MS",
      "Geneva",
      "Monaco",
      "Copperplate",
      "Brush Script",
      "Franklin Gothic",
      "Futura",
      "Baskerville",
      "Didot",
      "Rockwell",
      "Arial Narrow",
    ];

    this.animationSpeeds = ["slow", "normal", "fast"];

    this.animationDirections = [
      { label: "Alternate", value: "left" },
      { label: "Alternate Reverse", value: "right" },
      { label: "Up ", value: "up" },
      { label: "Down", value: "down" },
    ];

    this.fontSizes = [
      { label: "1 Pixel", value: "1rem" },
      { label: "2 Pixels", value: "2rem" },
      { label: "3 Pixels", value: "3rem" },
      { label: "4 Pixels", value: "4rem" },
      { label: "5 Pixels", value: "5rem" },
      { label: "6 Pixels", value: "5rem" },
    ];
  }

  filteredBackgroundImages = () => {
    const { tickerBackgroundImages } = this.props;
    const { searchBgImage } = this.state;

    // Filter the images based on the search query
    return tickerBackgroundImages.filter((bg) =>
      bg.name.toLowerCase().includes(searchBgImage.toLowerCase())
    );
  };

  handleTabClick = (tab) => {
    this.setState({ activeTab: tab });
  };

  handleBackgroundTypeChange = (e) => {
    this.setState({ selectedBackgroundType: e.target.value });
  };

  handleBackgroundColorChange = (e) => {
    this.setState({ selectedBackgroundColor: e.target.value });
  };

  handleTextInputChange = (e) => {
    this.setState({ textInput: e.target.value });
  };

  handleFontSizeChange = (e) => {
    this.setState({ selectedFontSize: e.target.value });
  };

  handleTextEffectChange = (e) => {
    this.setState({ selectedTextEffect: e.target.value });
  };

  handleMotionEffectChange = (e) => {
    this.setState({ selectedMotionEffect: e.target.value });
  };

  handleFontFamilyChange = (e) => {
    this.setState({ selectedFontFamily: e.target.value });
  };

  handleTextColorChange = (color) => {
    this.setState({ selectedTextColor: color });
  };

  handleSpeedChange = (e) => {
    this.setState({ selectedSpeed: e.target.value });
  };

  handleFileNameChange = (e) => {
    this.setState({ fileName: e.target.value });
  };

  handleBackgroundImageChange = (bg) => {
    this.setState({ selectedBackgroundImage: bg });
  };

  handleAnimationDirectionChange = (e) => {
    this.setState({ selectedAnimationDirection: e.target.value });
  };

  handleModifyCheckbox = () => {
    this.setState({ modifyPrevAsset: !this.state.modifyPrevAsset });
  };
  handleSelectedAsset = (id, name) => {
    this.setState({ selectedAsset: id });
    this.setState({ assetSearchQuery: name });
  };

  handleTickerBgSearch = (e) => {
    this.setState({ searchBgImage: e.target.value });
  };

  handleAssetSearchChange = (e) => {
    this.setState({ assetSearchQuery: e.target.value });
  };

  generateHTMLContent = () => {
    const {
      selectedBackgroundType,
      selectedTextEffect,
      selectedTextColor,
      selectedMotionEffect,
      selectedSpeed,
      selectedFontFamily,
      textInput,
      selectedBackgroundImage,
      selectedBackgroundColor,
      selectedAnimationDirection,
      selectedFontSize,
    } = this.state;

    let textStyles = `text-decoration: ${selectedTextEffect}; color: ${selectedTextColor}; font-family: ${selectedFontFamily};`;

    if (selectedMotionEffect === "slide") {
      textStyles += ` animation: slide ${selectedSpeed} 2s infinite;`;
    } else if (selectedMotionEffect === "rotate") {
      textStyles += ` animation: rotate ${selectedSpeed} 2s infinite; animation-direction:${selectedAnimationDirection};`;
    }

    return `
      <html>
      <style>
      /* styles.scss */
@keyframes slide {
    0% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(20px);
    }
    100% {
      transform: translateX(0);
    }
  }
  
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(10deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  
      </style>
        <body style="background-color: ${selectedBackgroundColor}; background-image: url('${selectedBackgroundImage}'); 
        background-size:cover;
         display: flex; justify-content: center; align-items: center; height: 100vh;" >
         <marquee  behaviour="scroll" direction=${selectedAnimationDirection} 
          style="font-size:${selectedFontSize}; text-decoration: ${selectedTextEffect}; 
         color: ${selectedTextColor}; font-family: ${selectedFontFamily}; font-style:${selectedTextEffect}; text-transform:${selectedTextEffect};">  
          ${textInput}
          </marquee>


        </body>
      </html>
    `;
  };

  // handleSaveClick = () => {
  //   const htmlContent = this.generateHTMLContent();
  //   const blob = new Blob([htmlContent], { type: "text/html" });
  //   const url = URL.createObjectURL(blob);
  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.download = "index.html";
  //   link.click();
  //   URL.revokeObjectURL(url);
  // };

  setStatesToNull() {
    this.setState({
      selectedBackgroundType: "none",
      selectedBackgroundColor: "#ffffff",
      selectedBackgroundImage: "",
      textInput: "Ticker Title",
      selectedTextEffect: "none",
      activeTab: "editor",
      selected: null,
      selectedFontFamily: "Arial",
      selectedMotionEffect: "none",
      selectedTextColor: "#000000",
      selectedSpeed: "normal",
      fileName: "",
      selectedAnimationDirection: "normal",
      selectedFontSize: "2rem",
      modifyPrevAsset: false,
      selectedAsset: null,
      searchBgImage: "",
      assetSearchQuery: "",
      // Add more states as needed
    });
  }

  handleSaveClick = () => {
    const { fileName } = this.state;
    const htmlContent = this.generateHTMLContent();

    // Create a new JSZip instance
    const zip = new JSZip();

    // Add the index.html file to the zip file
    zip.file("index.html", htmlContent);

    // Generate the zip file asynchronously
    zip.generateAsync({ type: "blob" }).then((blob) => {
      // Create a File object from the generated blob
      const file = new File([blob], fileName + "-scroller.zip", {
        type: "application/zip",
      });

      // Upload the zip file using props.upload
      this.props.uploadAsset(file);
      this.setStatesToNull();
    });
  };
  // ... (rest of the code remains the same)

  handleModifyPreviousAsset = () => {
    const { selectedAsset } = this.state;
    const htmlContent = this.generateHTMLContent();

    // Create a new JSZip instance
    const zip = new JSZip();

    // Add the index.html file to the zip file
    zip.file("index.html", htmlContent);

    // Generate the zip file asynchronously
    zip.generateAsync({ type: "blob" }).then((blob) => {
      const media_file = new File([blob], "index" + ".zip", {
        type: "application/zip",
      });

      if (selectedAsset != null) {
        this.props.updateScrollerAsset(selectedAsset, media_file, true);
        this.props.updateScrollerAsset(selectedAsset, media_file, false);
        this.setStatesToNull();
      }
    });
  };

  render() {
    console.log("bg url", this.state.selectedBackgroundColor);
    const {
      selectedBackground,
      selectedTextEffect,
      selectedTextColor,
      selectedMotionEffect,
      selectedFontFamily,
      textInput,
      fileName,
      activeTab,
      selectedBackgroundType,
      selectedBackgroundColor,
      selectedBackgroundImage,
      selectedAnimationDirection,
      selectedFontSize,
      modifyPrevAsset,
      selectedAsset,
      searchBgImage,
      assetSearchQuery,
    } = this.state;

    const { assets } = this.props;
    console.log(assets);

    return (
      <div className="asset-editing-page">
        <div className="tabs-container">
          <div className="tab-content">
            {activeTab === "editor" && (
              <div className="editor-tab">
                <div
                  className="preview-tab"
                  style={{
                    backgroundColor: selectedBackgroundColor,
                    backgroundImage: `url('${selectedBackgroundImage}')`,
                    textAlign: "center",
                    height: "15rem",
                    backgroundSize: "cover",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: this.generateHTMLContent(),
                  }}
                />
                <div>
                  <label htmlFor="text-input">Text:</label>
                  <input
                    type="text"
                    id="text-input"
                    value={textInput}
                    onChange={this.handleTextInputChange}
                  />
                </div>

                <div>
                  <label htmlFor="text-effect">Text Size:</label>
                  <select
                    id="text-effect"
                    value={selectedFontSize}
                    onChange={this.handleFontSizeChange}
                  >
                    {this.fontSizes.map((size) => (
                      <option key={size} value={size.value}>
                        {size.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label htmlFor="font-family">Font Family:</label>
                  <select
                    id="font-family"
                    value={selectedFontFamily}
                    onChange={this.handleFontFamilyChange}
                  >
                    {this.fontFamilies.map((fontFamily) => (
                      <option key={fontFamily} value={fontFamily}>
                        {fontFamily}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label htmlFor="text-effect">Text Effect:</label>
                  <select
                    id="text-effect"
                    value={selectedTextEffect}
                    onChange={this.handleTextEffectChange}
                  >
                    {this.textEffects.map((effect) => (
                      <option key={effect} value={effect}>
                        {effect}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label htmlFor="animation-direction">Direction:</label>
                  <select
                    id="animation-direction"
                    value={selectedAnimationDirection}
                    onChange={this.handleAnimationDirectionChange}
                  >
                    {this.animationDirections.map((direction) => (
                      <option key={direction} value={direction.value}>
                        {direction.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label htmlFor="text-color">Text Color:</label>
                  <input
                    type="color"
                    id="text-color"
                    value={selectedTextColor}
                    onChange={(e) => this.handleTextColorChange(e.target.value)}
                  />
                </div>

                <div>
                  <label htmlFor="bgType">Background:</label>
                  <select
                    id="bgType"
                    value={this.state.selectedBackgroundType}
                    onChange={this.handleBackgroundTypeChange}
                  >
                    <option value="none">None</option>
                    <option value="bgColor">Background Color</option>
                    <option value="bgImage">Background Image</option>
                  </select>
                </div>

                {selectedBackgroundType === "bgColor" && (
                  <div>
                    <label htmlFor="bgColor">Background Color:</label>
                    <input
                      type="color"
                      id="bgColor"
                      value={selectedBackgroundColor}
                      onChange={this.handleBackgroundColorChange}
                    />
                  </div>
                )}

                {selectedBackgroundType === "bgImage" && (
                  <div className="bgImage">
                    <label htmlFor="bgImage">Background Image</label>
                    <input
                      type="text"
                      placeholder="Search images..."
                      value={searchBgImage}
                      onChange={this.handleTickerBgSearch}
                    />
                    <div className="thumbnail-box">
                      {this.filteredBackgroundImages().map((bg) => (
                        <div
                          key={bg.asset_url}
                          className={`thumbnail ${
                            bg.asset_url === selectedBackgroundImage
                              ? "tickselected"
                              : ""
                          }`}
                          style={{
                            backgroundImage: `url(${bg.asset_url})`,
                          }}
                          onClick={() =>
                            this.handleBackgroundImageChange(bg.asset_url)
                          }
                        >
                          <div className="thumbnail-name">
                            {bg.name && bg.name.length > 7
                              ? `${bg.name.slice(0, 7)}..`
                              : bg.name}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="mt-1">
                  <label htmlFor="text-color">Modify Previous Asset:</label>
                  <input
                    type="checkbox"
                    checked={modifyPrevAsset}
                    onChange={this.handleModifyCheckbox}
                  />
                </div>

                {modifyPrevAsset === false ? (
                  <div>
                    <label htmlFor="text-input">File name:</label>
                    <input
                      type="text"
                      placeholder="scroller filename .."
                      value={fileName}
                      onChange={this.handleFileNameChange}
                    />
                  </div>
                ) : (
                  <div>
                    <div className="custom-dropdown">
                      <div className="ticker-bg">
                        <input
                          type="text"
                          placeholder="Search assets..."
                          value={assetSearchQuery}
                          onChange={this.handleAssetSearchChange}
                        />
                      </div>
                      <div className="asset-list">
                        <ul>
                          {assets
                            .filter((asset) => asset.type === "ZIP")
                            .filter((asset) =>
                              asset.name
                                .toLowerCase()
                                .includes(assetSearchQuery.toLowerCase())
                            )
                            .filter((asset) =>
                              asset.name.toLowerCase().endsWith("-scroller.zip")
                            )
                            .map((asset) => (
                              <li
                                key={asset.id}
                                className={
                                  selectedAsset === asset.id
                                    ? "asset-selected"
                                    : ""
                                }
                                onClick={() =>
                                  this.handleSelectedAsset(asset.id, asset.name)
                                }
                              >
                                {asset.name}
                              </li>
                            ))}
                          {assets
                            .filter((asset) => asset.type === "ZIP")
                            .filter((asset) =>
                              asset.name
                                .toLowerCase()
                                .includes(assetSearchQuery.toLowerCase())
                            )
                            .filter((asset) =>
                              asset.name.toLowerCase().endsWith("-scroller.zip")
                            ).length === 0 && (
                            <li className="no-assets">No assets found</li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                <div className="flex flex-ai-c flex-jc-sb">
                  <div></div>
                  {modifyPrevAsset === false ? (
                    <Button
                      isDisabled={fileName.trim().length == 0}
                      className="save-button"
                      onClick={this.handleSaveClick}
                    >
                      Save Asset
                    </Button>
                  ) : (
                    <Button
                      // isDisabled={selectedAsset === null}
                      className="save-button"
                      onClick={this.handleModifyPreviousAsset}
                    >
                      Modify Asset
                    </Button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state, props) => {
    return {
      tickerBackgroundImages: getScrollerTemplates(state),
      assets: getFilteredAssetsByQuery(state, ""),

      // isFetching: isFetching(state)
    };
  },
  {
    uploadAsset,
    updateScrollerAsset,
    fetchScrollerTemplates,
    fetchAssets,
    addZipAsset,
  }
)(ScrollerAppPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetModal/components/Scroller.js